import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store= new Vuex.Store({
  state: {
      language:localStorage.LANGUAGE|| navigator.language,
      token:localStorage.TOKEN||'',
      user:localStorage.USER?JSON.parse(localStorage.USER):{},
      list:{pageSize:localStorage.PAGESIZE? parseInt( localStorage.PAGESIZE)||10:10,pageIndex:0},
	  operate:'',
	  select:[],
	  menu:{},
	  height:document.body.clientHeight
  },
  mutations: {
      saveToken(state, data) {
          state.token = data;
          localStorage.setItem("TOKEN", data);
      },
      saveUser(state, data) { 
        state.user = data;
        localStorage.setItem("USER",JSON.stringify(data));
    },
      saveLanguage: (state, data) => {
          state.language = data
          localStorage.setItem('LANGUAGE', data)
      },
      saveList: (state, data) => {
		  if(!data.pageSize){
			  data.pageSize=parseInt(localStorage.PAGESIZE)||10;
			  data.pageIndex=1;
		  }
		    state.select =[];
        state.list = data
    },
	saveOperate: (state, data) => {
	    state.operate = data
	},
	saveSelect: (state, data) => {
	    state.select = data
	},
	saveMenu: (state, data) => {
	    state.menu = data
		if(!data.isLock){ state.select =[];
		 state.list = {pageSize:localStorage.PAGESIZE? parseInt( localStorage.PAGESIZE)||10:10,pageIndex:0}
		 }
		localStorage.setItem("MENU",JSON.stringify(data));
	},
	saveHeight: (state, data) => {
	    state.height = data
	},
  },
  actions: {
      setLanguage({ commit }, language) {
          commit('saveLanguage', language)
      },

  }
})

export default store

